import { gql } from '@apollo/client'
import { CLEAR_SESSION, SET_SESSION } from '../constants/actionTypes'
import cognitoUtils from '../lib/cognitoUtils'
import apolloClient from '../lib/apolloClient'

export const clearSession = () => ({
  type: CLEAR_SESSION
})

const VIEWER_QUERY = gql`
  query Viewer {
    viewer {
      id
      email
      capabilities
    }
  }
`

// Fetch the caller's capabilities from the backend. Fail closed: any error
// (query not yet deployed, network failure, etc.) degrades to no capabilities
// so the Devices menu/route stay hidden, without blocking the rest of the app.
function fetchCapabilities () {
  return apolloClient
    .query({ query: VIEWER_QUERY, fetchPolicy: 'network-only' })
    .then(({ data }) => (data && data.viewer && data.viewer.capabilities) || [])
    .catch((err) => {
      console.warn('Failed to fetch viewer capabilities; defaulting to none.', err)
      return []
    })
}

// Augment a resolved Cognito session with backend capabilities.
function withCapabilities (session) {
  return fetchCapabilities().then((capabilities) => ({ ...session, capabilities }))
}

// Initialise the Cognito sesson from a callback href
export function initSessionFromCallbackURI (callbackHref) {
  return function (dispatch) {
    return cognitoUtils.parseCognitoWebResponse(callbackHref) // parse the callback URL
      .then(() => cognitoUtils.getCognitoSession()) // get a new session
      .then(withCapabilities)
      .then((session) => {
        dispatch({ type: SET_SESSION, session })
      })
  }
}

export function initSessionFromCookie () {
  return function (dispatch) {
    return cognitoUtils.getCognitoSession()
        .then(withCapabilities)
        .then(session => {dispatch({ type: SET_SESSION, session })})
        .catch(err => {dispatch(clearSession())});
  }
}

export const setSession = session => ({
  type: SET_SESSION,
  session
})
